<template>
  <div
    @click.stop="updateValue"
    :class="{ disabled: disabled }"
    class="flex-radio"
  >
    <div :class="{ 'active-radio': isActive }" class="c-radio">
      <svg
        v-if="isActive"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        fill="none"
        class="transform origin-center"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      >
        <path d="M5 13l4 4L19 7"></path>
      </svg>
    </div>
    <span>{{ label }}</span>
  </div>
</template>

<script>
export default {
  name: "Radio",
  props: {
    value: [String, Number, Boolean],
    name: String,
    disabled: Boolean,
    label: String,
    options: Array,
  },
  data() {
    return {
      items: this.options || [true, false],
      isActive: false,
    };
  },
  watch: {
    value: {
      handler(newVal) {
        this.isActive = newVal === this.items[0];
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    updateValue() {
      if (!this.disabled) {
        this.$emit("input", this.items[0]);
        this.onchange(this.items[0]);
      }
    },

    onchange(value) {
      this.$emit("onchange", value);
    },
  },
};
</script>

<style scoped>
.c-radio {
  width: 20px;
  height: 20px;
  border: 1px solid var(--dark-light);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: border 0.2s ease, background 0.2s ease;
  cursor: pointer;
}

.c-radio.active-radio {
  border-color: var(--primary);
  background-color: var(--primary);
  color: var(--white);
}

.flex-radio {
  display: flex;
  align-items: center;
  gap: 8px;
  user-select: none;
  cursor: pointer;
  width: fit-content;
}

.flex-radio:hover .c-radio {
  border-color: var(--primary);
  color: var(--white);
}

.flex-radio.disabled {
  cursor: not-allowed;
  opacity: 0.6;
  pointer-events: none;
}

.flex-radio span {
  padding-top: 3px;
}
</style>
